import { AspectRatio, Flex, SimpleGrid, Text, VStack } from '@chakra-ui/react'

import Image from 'next/image'

import ThreeBottle from './three-bottle'
import Link from 'next/link'

const Item = ({
  title,
  src,
  ratio = 1 / 1
}: {
  title: string
  src: any
  ratio?: any
}) => {
  return (
    <VStack gap={2}>
      <VStack
        w="100%"
        minH={{
          base: '70px',
          sm: '90px',
          xl: '100px'
        }}
        justifyContent="center"
      >
        <AspectRatio
          w={{
            base: '60px',
            sm: '80px',
            xl: '90px'
          }}
          ratio={ratio}
          position="relative"
        >
          <Image src={src} alt={title} fill />
        </AspectRatio>
      </VStack>
      <Text
        lineHeight={1.1}
        fontSize={{
          base: '14px',
          sm: '15px'
        }}
        textAlign="center"
        fontFamily="Inter"
        fontWeight={500}
        zIndex={100}
        maxW="150px"
        color={'#fff'}
      >
        {title}
      </Text>
    </VStack>
  )
}

const Deals = () => {
  return (
    <VStack my={10} alignItems="center">
      <Flex
        data-aos="fade-up"
        flexDir={{
          base: 'column',
          md: 'row'
        }}
        w={{
          base: '70%',
          md: '100%'
        }}
        justifyContent="center"
        alignItems="center"
        gap={{
          base: 4,
          md: 0
        }}
        mt={{
          base: 8,
          md: 10
        }}
      >
        <ThreeBottle isHero={false} />
      </Flex>
      <Text
        data-aos="fade-up"
        textStyle="oralcareDealsTittle"
        textAlign="left"
        color="#fff"
        mt={{
          base: 2,
          md: 4
        }}
      >
        Health+ Oralcare Mouthwash
      </Text>

      <AspectRatio
        data-aos="fade-up"
        ratio={1537 / 864}
        w={{
          base: '120px',
          sm: '120px',
          md: '140px',
          lg: '160px'
        }}
        _hover={{
          opacity: 0.7
        }}
      >
        <Link href="https://habbit.sg/products/health+oralcare">
          <Image
            src={
              'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/white-btn-1714036950428.png'
            }
            alt="buy now btn"
            fill
          />
        </Link>
      </AspectRatio>

      <SimpleGrid
        data-aos="fade-up"
        columns={{ base: 2, md: 4 }}
        gap={4}
        w={{
          base: '80%',
          md: '76%'
        }}
        mt={5}
      >
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-one-1714036950425.png'
          }
          title="Triple cleaning effect"
          ratio={1537 / 864}
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-two-1714036950427.png'
          }
          title="Improve your oral health"
          ratio={1537 / 864}
        />
        <Item
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-three-1714036950426.png'
          }
          title="Natural ingredients"
          ratio={1537 / 864}
        />
        <Item
          ratio={1537 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-four-1714036950423.png'
          }
          title="Brightens & strengthens teeth"
        />
      </SimpleGrid>
      <SimpleGrid
        data-aos="fade-up"
        columns={{ base: 2, md: 5 }}
        gap={4}
        w={{
          base: '80%',
          md: '96%'
        }}
        mt={5}
      >
        <Item
          ratio={1537 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-five-1714036950422.png'
          }
          title="Coagulates & removes protein"
        />
        <Item
          ratio={1537 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-six-1714036950426.png'
          }
          title="Suitable for 5 years and above & pregnant ladies"
        />
        <Item
          ratio={1537 / 758}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-eight-1714036950417.png'
          }
          title="Prevent gum disease & bad breath"
        />
        <Item
          ratio={1537 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-seven-1714036950425.png'
          }
          title="Remove tough stains"
        />

        <Item
          ratio={1537 / 864}
          src={
            'https://habbit-sg.s3.ap-southeast-1.amazonaws.com/deals-nine-1714036950424.png'
          }
          title="Non alcohol, non toxic, no bleaching agent"
        />
      </SimpleGrid>
    </VStack>
  )
}

export default Deals
